import { jsx as i } from "react/jsx-runtime";
import { IressTableFormattedValue as p } from "../TableFormattedValue/TableFormattedValue.js";
import { formatObjectKey as b } from "../../../utils/helpers.formatting.js";
import { b as f } from "../../../index-BlUIIy6G.js";
const m = (o, a) => {
  const s = f();
  return a ? Object.entries(a).map(([r, e]) => s.accessor((t) => t[r], {
    id: r,
    cell: (t) => /* @__PURE__ */ i(
      p,
      {
        format: e == null ? void 0 : e.format,
        value: t.getValue(),
        row: t.row.original
      }
    ),
    header: () => e == null ? void 0 : e.label,
    enableSorting: !!(e != null && e.sort)
  })) : Object.keys(o[0] ?? {}).map(
    (r) => s.accessor((e) => e[r], {
      id: r,
      cell: (e) => e.getValue(),
      header: () => b(r),
      enableSorting: !1
    })
  );
};
export {
  m as composeIDSTableColumnDefs
};
